<template>
    <div v-if="commodity && commodity.length"
         style="padding: 0 0.333333rem;border-top: 1px solid #f4f5f6;">
        <div>
            <h2>
                <strong>视频同款</strong>
                <small style="float: right;">
                    <router-link style="vertical-align: sub;"
                                 :to="{path:'/store',query:{userId: commodity[0].userId}}">进入店铺 ></router-link>
                </small>
            </h2>
        </div>
        <div class="live-list"
             style="padding: 0 0 0.333333rem 0;">
            <div style="margin: 0 0.1rem;"
                 v-for="(o, index) in commodity"
                 :key="index">
                <a :href="o.address">
                    <el-card :body-style="{ padding: '0px', width: '120px'}"
                             shadow="never">
                        <img :src="o.image"
                             :style="{  width: '120px', height: '120px'}"
                             class="image">
                        <div style="padding: 0.2rem;">
                            <div class="elip"><strong>{{o.name}}</strong></div>
                            <div class="bottom clearfix">
                                <time class="price">{{ o.price.split("~")[0] }}</time>
                            </div>
                        </div>
                    </el-card>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data () {
        return {
            commodity: []
        }
    },
    props: {
        id: String
    },
    mounted () {
        this.axios.get("/live/commodity?liveId=" + this.id).then(res => {
            this.commodity = res.data.data;
        })
    }
}
</script>

<style scoped>
.elip {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.price {
    font-size: 13px;
    color: #ff0036;
    vertical-align: middle;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.image {
    width: 100%;
    display: block;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}
</style>
